var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.63927,2.335601C11.5589,1.853413,11.14171,1.5,10.65287,1.5L5.34713,1.5C4.85829,1.5,4.4411000000000005,1.853413,4.36073,2.335601L4.16667,3.5L2,3.5L2,4.5L3.0454499999999998,4.5L3.45661,13.5454C3.48089,14.0795,3.92095,14.5,4.455579999999999,14.5L11.54442,14.5C12.0791,14.5,12.5191,14.0795,12.5434,13.5454L12.9545,4.5L14,4.5L14,3.5L11.83333,3.5L11.63927,2.335601ZM10.81869,3.5L10.65169,2.5L5.34681,2.5L5.17969,3.5L10.81869,3.5ZM11.95387,4.5L4.04688,4.5L4.45645,13.5L11.5453,13.5L11.95387,4.5ZM7,11.5L7,6.5L6,6.5L6,11.5L7,11.5ZM10,11.5L10,6.5L9,6.5L9,11.5L10,11.5Z",
    fillRule: "evenodd",
    fill: "#222222",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.61cb03c1dc0ac459a61fe91c8a60e7da.svg";
export { ForwardRef as ReactComponent };